import React from "react";
import { IoArrowBackOutline } from "react-icons/io5";

export default function MasterViewPage({
  description,
  fields,
  onBack,
  title,
}) {
  return (
    <div className="masters-card">
      <div className="masters-card__header">
        <div>
          <h1 className="masters-card__title">{title}</h1>
          <p className="masters-card__description">{description}</p>
        </div>

        <div className="masters-card__actions">
          <button
            className="masters-btn masters-btn--secondary"
            onClick={onBack}
            type="button"
          >
            <IoArrowBackOutline />
            Back
          </button>
        </div>
      </div>

      <div className="masters-detail-grid">
        {fields.map((field) => (
          <div className="masters-detail-item" key={field.label}>
            <span className="masters-detail-item__label">{field.label}</span>
            <div className="masters-detail-item__value">{field.value || "-"}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
